angular.module('impactx.invoice').controller('InvoiceItemEditCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'invoiceItem',
    'currency',
    'taxRate',
    'unit',
    'confirmLabel',
    'abortLabel',
    'requiredLabel',
    'noSelectedItemMessage',
    'headerLabel',
    'TranslationService',
    'dataGen',
    'orderComId',
    'cscId', 'noPriceMatchError', 'missingPriceAmountError', 'missingUnitPriceError', 'trns',
    InvoiceItemEditCtrl]);

function InvoiceItemEditCtrl($scope, $mdDialog, themeFactory, invoiceItem, currency, taxRate, unit, confirmLabel, abortLabel,
                             requiredLabel, noSelectedItemMessage, headerLabel, TranslationService, dataGen, orderComId,
                             cscId ,noPriceMatchError, missingPriceAmountError, missingUnitPriceError, trns) {
    var ctrl = this;
    $scope.errorList = [];
    $scope.invoiceItem = JSON.parse(JSON.stringify(invoiceItem));
    $scope.currency = currency;
    $scope.taxRate = taxRate;
    $scope.unit = unit;
    $scope.required = true;
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.requiredLabel = requiredLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.headerLabel = headerLabel;
    $scope.noPriceMatchError = noPriceMatchError;
    $scope.missingPriceAmountError = missingPriceAmountError;
    $scope.missingUnitPriceError = missingUnitPriceError;
    $scope.trns = trns;

    $scope.theme = themeFactory.getTheme();
    $scope.readOnly = $scope.invoiceItem.poiId > 0; // item is order related
    $scope.zeroNotAllowedLabel = TranslationService.get("zeroNotAllowed");

    ctrl.getTaxRates = function () {
        var params = {
            taxDate: $scope.invoiceItem.deliveryDate,
            orderComId: orderComId,
            cscId: cscId,
            selectedTax: $scope.invoiceItem.price.taxRate.selected.id
        };
        dataGen.postAsForm({}, params, "/invoice/taxrates").then(function (data) {
            if (data && data.data && data.data.entries) {
                $scope.invoiceItem.price.taxRate.entries = data.data.entries;
                $scope.invoiceItem.price.taxRate.secondEntries = data.data.additionalEntries;
                var selected = $scope.invoiceItem.price.taxRate.selected;
                if (selected) {
                    var validEntries = data.data.entries.filter(function (entry) {
                        return entry.id === selected.id;
                    });
                    var isValid = validEntries.length > 0;
                    if (!isValid) {
                        if ($scope.invoiceItem.showAdditionalTaxRates) {
                            validEntries = data.data.additionalEntries.filter(function (entry) {
                                return entry.id === selected.id;
                            });
                            isValid = validEntries.length > 0;
                            if (!isValid) {
                                delete $scope.invoiceItem.price.taxRate.selected;
                            }
                        }
                        else {
                            delete $scope.invoiceItem.price.taxRate.selected;
                        }
                    }
                    if(isValid) {
                        $scope.invoiceItem.price.taxRate.selected = validEntries[0];
                        $scope.invoiceItem.price.taxRate.selected.taxId = data.data.selectedTaxId;
                    }
                }
            }
        });
    };

    ctrl.updateViewData = function () {
        $scope.errorList.length = 0;
        if ($scope.invoiceItem.orderUnitPrice && $scope.invoiceItem.orderUnitPrice.value && $scope.invoiceItem.orderUnitPrice.value !== 0) {

            if ($scope.invoiceItem.ouPriceAmount.value && parseInt($scope.invoiceItem.ouPriceAmount.value) !== 0) {
                if ($scope.invoiceItem.orderUnitPrice.value !== (parseInt($scope.invoiceItem.ouPriceAmount.value) * $scope.invoiceItem.price.netValue.value)) {
                    $scope.errorList.push($scope.noPriceMatchError);
                }
            } else {
                $scope.errorList.push($scope.missingPriceAmountError);
            }
        } else if ($scope.invoiceItem.ouPriceAmount && $scope.invoiceItem.ouPriceAmount.value && parseInt($scope.invoiceItem.ouPriceAmount.value) !== 0
            && parseInt($scope.invoiceItem.ouPriceAmount.value) !== 1) {
            $scope.errorList.push($scope.missingUnitPriceError);
        }
    }

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    ctrl.confirm = function () {
        invoiceItem.productName = $scope.invoiceItem.productName;
        invoiceItem.supplierNo = $scope.invoiceItem.supplierNo;
        invoiceItem.amount = $scope.invoiceItem.amount;
        invoiceItem.unit = $scope.invoiceItem.unit;
        $scope.invoiceItem.price.totalNetValue = $scope.invoiceItem.price.netValue.value * invoiceItem.amount.value;
        invoiceItem.price = $scope.invoiceItem.price;
        invoiceItem.sapPosition = $scope.invoiceItem.sapPosition;
        invoiceItem.deliveryDate = $scope.invoiceItem.deliveryDate;
        invoiceItem.orderUnitPrice = $scope.invoiceItem.orderUnitPrice;
        invoiceItem.ouPriceAmount = $scope.invoiceItem.ouPriceAmount;
        invoiceItem.showAdditionalTaxRates = $scope.invoiceItem.showAdditionalTaxRates;
        $mdDialog.hide();
    };

    if (!$scope.invoiceItem.price.taxRate.entries || $scope.invoiceItem.price.taxRate.entries.length === 0) {
        ctrl.getTaxRates();
    }
    else if ($scope.invoiceItem.price.taxRate.selected && !$scope.invoiceItem.price.taxRate.selected.taxId) {
        var found = false;
        for (var i = 0; i < $scope.invoiceItem.price.taxRate.entries.length; i++) {
            if ($scope.invoiceItem.price.taxRate.selected.id === $scope.invoiceItem.price.taxRate.entries[i].id) {
                $scope.invoiceItem.price.taxRate.selected = $scope.invoiceItem.price.taxRate.entries[i];
                found = true;
                break;
            }
        }
        if (!found && $scope.invoiceItem.showAdditionalTaxRates) {
            for (var i = 0; i < $scope.invoiceItem.price.taxRate.secondEntries.length; i++) {
                if ($scope.invoiceItem.price.taxRate.selected.id === $scope.invoiceItem.price.taxRate.secondEntries[i].id) {
                    $scope.invoiceItem.price.taxRate.selected = $scope.invoiceItem.price.taxRate.secondEntries[i];
                    break;
                }
            }
        }
    }
}
